import {getUrlParams} from '@rambler-id/url'
import {loadScript} from 'utils/dom'
import type {RamblerPlayer} from 'sdk/rambler-player'
import styles from './styles.scss'

/**
 * API handle should renders the following html to export video's meta data
 * to social networks
 *
 * ```html
 * <!DOCTYPE html>
 * <html>
 * <head>
 *   <meta charset="utf-8">
 *   <title>{title}</title>
 *   <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
 *   <meta name="description" content="{description}">
 *   <meta property="og:title" content="{title}">
 *   <meta property="og:description" content="{description}">
 *   <meta property="og:image" content="{screenshot}">
 *   <meta property="og:video" content="{current_url}">
 * </head>
 * <body>
 *   <script src="https://{player_host}/player/export.js"></script>
 * </body>
 * </html>
 * ```
 */

const VERSION = process.env.VERSION
const CDN_ORIGIN = process.env.CDN_ORIGIN
const CDN_PREFIX = process.env.CDN_PREFIX

const mount = async (): Promise<void> => {
  const query: any = getUrlParams(window.location.href)

  if (!query.referrer) {
    query.referrer = document.referrer
  }

  if (query.uuid) {
    query.id = query.uuid
    delete query.uuid
  }

  const parent = document.createElement('div')

  parent.className = styles.parent
  document.body.appendChild(parent)

  const Player: typeof RamblerPlayer = await new Promise((resolve) => {
    window.RamblerPlayer = window.RamblerPlayer || []
    window.RamblerPlayer.push(() => resolve(window.RamblerPlayer))
    loadScript(`${CDN_ORIGIN}${CDN_PREFIX}/${VERSION}/sdk.js`)
  })

  new Player({...query, parent})
}

mount()
